import React, { Component } from 'react';
import { Redirect,Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Moment from 'react-moment';
import ReactHtmlParser from 'react-html-parser';
import { userGroupUrlCheck,getUserTimeZone } from '../../utils/userGroupUrlCheck';
import Toast from '../commons/helpers/toast';
import { clearAction } from '../../actions/commonActions'; 
import { activityLogListAction } from '../../actions/activityLogActions'; 
import { ACTIVITY_LOG_LIST_SUCCESS, ACTIVITY_LOG_LIST_ERROR } from '../../actions';
import * as staticConfigs from '../../configs/staticConfigs'; 
import { MSG_ACTIVITY_LOG_ERROR,MSG_SERVER_DATA_FETCH_ERROR } from '../../configs/msgConfigs';
import { LBL_EVENT,LBL_SHIFT,LBL_VIEW_MORE,LBL_USER_ACTION_LOGS } from '../../configs/labelConfigs'; // LBL_QUOTE

import { converDateToLocal } from '../../utils/commonUtilities';

class LogComponent extends Component { 

    constructor(props){
        super();

        this.state = {
            allLogItems: [], 
            logLinks: {},
            arrLogResults: [], 
            userGroupId: '', 
            toastMessage: '',
            toastFlag: false,
            toastSuccess: true, 
            isFilterOn: false,
            errLogResultsMsg: '',
            logCalled: 0,
            logType: '',
            logTypeId: 0,
            pageSize:staticConfigs.PAGENUMROWS_ACTIVITY_LOG,
            hasMore:false,
            nextPage: 1        
        }
    }

    parseLog = (logString,logData,logAction,userGroup,timeZoneOffset) =>{
        let regexp = /<<(.*?)>>/g; 
        let matchAll = logString.matchAll(regexp);
        matchAll = Array.from(matchAll);
        // logString:  <<userby>> from <<client_company_name>> added a shift in project <<event_name>> 
        // logData: { "event": {"id": 67, "type": "event", "title": "CRM Test Client"}, 
        //              "userby": {"id": 130, "type": "user", "group": "client", "title": "test testing"}, 
        //              "client_profile": {"id": 2, "type": "client_profile", "title": "Client"}
        // }
        // <<userby>> from <<affiliate_profile>> has modified the time of shift <<shift>> in the project <<event>> from <<previous_start>> - <<previous_end>> to <<current_start>> - <<current_end>>.
        let dateElements = ['current_start', 'current_end', 'previous_start', 'previous_end']; 

        // ******** SUPERADMIN DETAILS - START *************************
        let logActionsMasterSuperAdmin =  {
            login_superadmin: staticConfigs.ROUTE_PROFILE, 
        }

        let logRouteIdsSuperAdmin =  {
        }
        // ******** SUPERADMIN DETAILS - END *************************

        // ******** AFFILIATES DETAILS - START *************************
        // FOR DELETE A QUOTE ONLY WE USE ACTION delete_events_by_affiliate
        // QUOTES ADDING LOG - FORWARD TO EVENT PAGE ONLY - 20May2021
        // add_events_by_affiliate : staticConfigs.ROUTE_AFFILIATE_QUOTES, 
        // add_events_by_affiliate : staticConfigs.ROUTE_CLIENT_QUOTES, 
        let logActionsAffiliate = { 
            delete_events_by_affiliate : staticConfigs.ROUTE_AFFILIATE_QUOTES, 
        } 

        let logActionsClient = { 
            delete_events_by_affiliate : staticConfigs.ROUTE_CLIENT_QUOTES, 
        } 

        // TO ACTIVATE THE LINKS IN LOGIN STRING, 
        // KEY IS COMBINTION OF 'CODE' IN <<CODE>> AND 'type' IN THE DATA OBJECT, FOR e.g.
        //  
        // "log_string": "<<userby>> has added new crew document <<crewdocument>> in settings."	
        // "content":{
        //    "userby": {"id": 23, "type": "user", "group": "affiliate", "title": "test12 test23"},     
        //    "crewdocument": {"id": 42, "type": "userdocs", "title": "test123", "user_type": 5}
        // } 
        // 
        // FOR <<crewdocument>> USE crewdocument_userdocs
        // ONLY IN CASE OF <<userby>>, APPEND ITS GROUP ALSO e.g. userby_user_affiliate 
        // WE ARE NOT USING action FIELD VALUE FOR REDIRECTIONS EXCEPT THE ACTION delete_events_by_affiliate 

        // IN logCodeRouteAffiliate, ONLY REDIRECTION TO DIFFERENT PAGES ARE DONE
        // TO REDIRECT WITH RESPECTED ID, USE logCodeRouteIdsAffiliate
        let logCodeRouteAffiliate =  { 
            userby_user_affiliate:                staticConfigs.ROUTE_AFFILIATE_ASSOCIATES, 
            affiliate_profile_affiliate_profile:  staticConfigs.ROUTE_AFFILIATE_PROFILE_MANAGE, 
            event_event :                         staticConfigs.ROUTE_AFFILIATE_EVENTS, 
            shift_shift:                          staticConfigs.ROUTE_AFFILIATE_SHIFT, 
            shift_name_shift:                     staticConfigs.ROUTE_AFFILIATE_SHIFT, 
            client_profile_client_profile:        staticConfigs.ROUTE_AFFILIATE_CLIENTS, 
            crew_profile_crew_profile:            staticConfigs.ROUTE_AFFILIATE_CREW,
            user2_associate_user:                 staticConfigs.ROUTE_AFFILIATE_ASSOCIATES, 
            skillname_skills:                     staticConfigs.ROUTE_AFFILIATE_SKILLS, 
            skillsname_skills:                    staticConfigs.ROUTE_AFFILIATE_SKILLS, 
            skill_skill:                          staticConfigs.ROUTE_AFFILIATE_SKILLS, 
            clientdocument_userdocs:              staticConfigs.ROUTE_AFFILIATE_CLIENT_DOCS, 
            crewdocument_userdocs:                staticConfigs.ROUTE_AFFILIATE_CREW_DOCS, 
            otherexpensesname_otherexpenses:      staticConfigs.ROUTE_AFFILIATE_OTHER_EXPENSES, 
            departmentsname_departments:          staticConfigs.ROUTE_AFFILIATE_DEPARTMENTS, 
            location_event_location:              staticConfigs.ROUTE_AFFILIATE_EVENT_LOCATIONS,
            location_key_location:                staticConfigs.ROUTE_AFFILIATE_KEY_LOCATIONS,
            userrole_role:                        staticConfigs.ROUTE_AFFILIATE_ROLES_PERMISSIONS, 
            userrole_role_permissions:            staticConfigs.ROUTE_AFFILIATE_ROLES_PERMISSIONS, 
            crew_crew:                            staticConfigs.ROUTE_AFFILIATE_CREW, 
            clientcategoryname_clientcategory:    staticConfigs.ROUTE_AFFILIATE_CLIENT_CATEGORY, 
            category_category:                    staticConfigs.ROUTE_AFFILIATE_CLIENT_CATEGORY,
            document_document:                    staticConfigs.ROUTE_AFFILIATE_CREW_DOCS, 
            userby_user_crew:                     staticConfigs.ROUTE_AFFILIATE_CREW,  
            chiefby_chiefby:                      staticConfigs.ROUTE_AFFILIATE_CREW_PROFILE, 
            crewby_crewby:                        staticConfigs.ROUTE_AFFILIATE_CREW_PROFILE, 
        } 
        
        // KEY IS COMBINTION OF 'CODE' IN <<CODE>> AND 'type' IN THE DATA OBJECT
        // THESE ROUTES WILL BE APPENDED WITH ITS RELATED IDS 
        let logCodeRouteIdsAffiliate =  { 
            client_profile_client_profile:  staticConfigs.ROUTE_AFFILIATE_CLIENT_PROFILE, 
            company_name_company_name:      staticConfigs.ROUTE_AFFILIATE_CLIENT_PROFILE, 
            event_event:                    staticConfigs.ROUTE_AFFILIATE_EVENTS, 
            event_name_event:               staticConfigs.ROUTE_AFFILIATE_EVENTS, 
            shift_shift:                    staticConfigs.ROUTE_AFFILIATE_SHIFT, 
            shift_name_shift:               staticConfigs.ROUTE_AFFILIATE_SHIFT, 
            crew_profile_crew_profile:      staticConfigs.ROUTE_AFFILIATE_CREW_PROFILE,
            crew_crew:                      staticConfigs.ROUTE_AFFILIATE_CREW_PROFILE,
            chiefby_chiefby:                staticConfigs.ROUTE_AFFILIATE_CREW_PROFILE, 
            crewby_crewby:                  staticConfigs.ROUTE_AFFILIATE_CREW_PROFILE, 
        }  
        // ******** AFFILIATES DETAILS - END *************************

        // ******** CLIENT DETAILS - START *************************
        let logCodeRouteClient =  { // KEY IS COMBINTION OF 'CODE' IN <<CODE>> AND 'type' IN THE DATA OBJECT
            client_profile_client_profile: staticConfigs.ROUTE_CLIENT_PROFILE_MANAGE, 
            event_event : staticConfigs.ROUTE_CLIENT_EVENTS, 
            userby_user_client:  staticConfigs.ROUTE_CLIENT_ASSOCIATES, 
        } // 

        // KEY IS COMBINTION OF 'CODE' IN <<CODE>> AND 'type' IN THE DATA OBJECT
        let logCodeRouteIdsClient =  { 
            event_event : staticConfigs.ROUTE_CLIENT_EVENTS, 
        }  
        // ******** CLIENT DETAILS - END *************************

        let objRoute = {}; 
        let objRouteIds = {}; 
        let objActions = {}
        if(userGroup===staticConfigs.LOGIN_SUPER_ADMIN_GROUP) {
            objRoute = logActionsMasterSuperAdmin;
            objRouteIds = logRouteIdsSuperAdmin; 
            objActions = {}
        }
        else if(userGroup===staticConfigs.LOGIN_AFFILIATE_GROUP) {
            objRoute = logCodeRouteAffiliate; // logActionsMasterAffiliate;
            objRouteIds = logCodeRouteIdsAffiliate; 
            objActions = logActionsAffiliate
        }
        else if(userGroup===staticConfigs.LOGIN_CLIENT_GROUP) {
            objRoute = logCodeRouteClient; // logActionsMasterAffiliate;
            objRouteIds = logCodeRouteIdsClient; 
            objActions = logActionsClient
        }

        let retStr = logString;
        let arrTmp = []; 
        //let arrItem = ''; 
        let codeElement = ''; 
        let codeValue = ''; 
        let dataObj = {}; 
        let titleData = ''; 
        let logTypeData = ''; 
        let filterRoute = []; 
        let hrefOpen = ''; 
        let hrefClose = ''; 
        let logCodeType = ''; 
        let idValue = ''; 
        let arrDt = []; 

        if(matchAll.length) {
            matchAll.forEach(arrItem => {
                arrTmp = String(arrItem).split(','); 
                codeElement = arrTmp[0]; 
                codeValue = String(arrTmp[1]); 
                dataObj = logData[codeValue];  
                
                if(dataObj) {
                    hrefOpen = ''; 
                    hrefClose = ''; 
                    titleData = (dataObj.title.trim().length) ? dataObj.title : 'unknown';

                    // IF DATE,  CONVERT IT TO PROFILE TIMEZONE 
                    if(titleData && titleData.length && dateElements.includes(codeValue)) { 
                        // arrDt = String(titleData).split('+'); 
                        titleData = converDateToLocal(titleData.replace(' ','T'),timeZoneOffset,'yyyymmddThhmm','-'); 
                        //titleData = converDateToLocal(arrDt[0].replace(' ','T'),timeZoneOffset,'yyyymmddThhmm','-'); 
                        console.log(titleData); 
                    }
                    else {     
                        idValue = (dataObj.id) ? '/'+dataObj.id : '';
                        // SOME ELEMENTS CONTAINS '-' (associate-user,event-location) SO REPLACE '-' with '_' TO MATCH THEM WITH OBJECT KEY REFERENCE 
                        logTypeData = (dataObj.type.trim().length) ? dataObj.type.replace('-', '_') : '';
                        let groupCode = ''; 
                        if(String(arrTmp[1])==='userby' && logData.userby && logData.userby.group) {
                            groupCode = '_'+logData.userby.group;  
                        }
                        logCodeType = String(arrTmp[1]+'_'+logTypeData+groupCode);
                        filterRoute = ''; 

                        if(objActions[logAction] && codeValue=='event') filterRoute = objActions[logAction]+idValue; 
                        else if(objRouteIds[logCodeType]) filterRoute = objRouteIds[logCodeType]+idValue; 
                        else if(objRoute[logCodeType]) filterRoute = objRoute[logCodeType]; 
                        else filterRoute = objRoute[logAction]; 
                        
                        // console.log('groupCode: '+groupCode+', logCodeType:'+logCodeType+', filterRoute:'+filterRoute+', codeElement:'+codeElement+', codeValue:'+codeValue);

                        if(filterRoute) {
                            hrefOpen = '<a href="'+filterRoute+'" title="">'; 
                            // hrefOpen = '<a href="#" target="_blank" title="">'; // TO OPEN IN NEW TAB
                            hrefClose = '</a>'; 
                        } 
                    }
                    retStr = retStr.replace(codeElement, hrefOpen+titleData+hrefClose); 
                }
            });
        }
        return retStr;
        // console.log('matchAll: '+JSON.stringify(matchAll)); 
    }  
    
    onCloseToast = () =>{
        this.setState({toastFlag:false,toastMessage:'',toastSuccess:true});
    } 

    callLogDetails = () =>  {
        // console.log('this.props.dataObj: '+JSON.stringify(this.props.dataObj));  
        // dataObj IS PASSED FROM EVENT_DETAILS / SHIFT_DETAILS PAGES
        let refType = '';
        let refId   = 0; 
        let logClicked = 0; 
        if(this.props.dataObj.hasOwnProperty('refType'))    refType     = this.props.dataObj.refType;
        if(this.props.dataObj.hasOwnProperty('refId'))      refId       = this.props.dataObj.refId;
        if(this.props.dataObj.hasOwnProperty('logClicked')) logClicked  = this.props.dataObj.logClicked;
        
        if((this.state.logTypeId!==refId || this.state.logType!==refType)  && (refType===LBL_EVENT || refType===LBL_SHIFT) && refId > 0 && logClicked > 0) {
            this.setState({nextPage:1, logType:refType, logTypeId:refId, arrLogResults:[]}); 
            this.props.activityLogListAction({refType:refType, refId:refId, page: 1, pageSize:this.state.pageSize});
        }
    }

    loadNextPage = () => {
        let userGroupData = userGroupUrlCheck(this.props.location);
        let userGroup = ''; 
        if(userGroupData!==undefined) userGroup = userGroupData.user_group; 

        let refType = '';
        let refId   = 0; 
        if(this.props.dataObj.hasOwnProperty('refType')) refType = this.props.dataObj.refType;
        if(this.props.dataObj.hasOwnProperty('refId'))   refId   = this.props.dataObj.refId;
        
        // if(userGroup===staticConfigs.LOGIN_SUPER_ADMIN_GROUP || userGroup===staticConfigs.LOGIN_AFFILIATE_GROUP) {
        //     this.props.activityLogListAction({refType:refType, refId:refId, page: this.state.nextPage, pageSize:this.state.pageSize});
        // }

        this.props.activityLogListAction({refType:refType, refId:refId, page: this.state.nextPage, pageSize:this.state.pageSize});
    }

    componentDidMount() {
        let userGroupData = userGroupUrlCheck(this.props.location);
        let userGroup = ''; 
        if(userGroupData!==undefined) userGroup = userGroupData.user_group; 
        if(userGroup===staticConfigs.LOGIN_AFFILIATE_GROUP){
            document.body.classList.add('body-affiliate'); 
        }else if(userGroup===staticConfigs.LOGIN_CLIENT_GROUP){
            document.body.classList.add('body-client'); 
        } else{
            document.body.classList.add('body-super');
        }
        let refType = '';
        let refId   = 0; 
        if(this.props.dataObj.hasOwnProperty('refType')) refType = this.props.dataObj.refType;
        if(this.props.dataObj.hasOwnProperty('refId'))   refId   = this.props.dataObj.refId;
        
        // IF THIS PAGE IS CALLED FROM MAIN MENU OF SUPERADMIN OR AFFILIATE THEN CALL activityLogListAction  on componentDidMount  
        // && (userGroup===staticConfigs.LOGIN_SUPER_ADMIN_GROUP || userGroup===staticConfigs.LOGIN_AFFILIATE_GROUP)
        if(refType==='logMasterPage') {
            this.props.activityLogListAction({refType:refType, refId:refId, page: this.state.nextPage, pageSize:this.state.pageSize});
        }
    } 

    componentDidUpdate(prevProps) {  
        const { status, activity, dataObj } = this.props;

        if(this.state.logCalled===0 || dataObj.refType!==this.state.logType || dataObj.refId!==this.state.logTypeId) {
            this.callLogDetails();
        }

        if (activity && (status !== prevProps.status || activity!==prevProps.activity)) {
            let arrLogResults = [];   
            let logLinks = {} 
            let errLogResultsMsg = ''; 
            var arrResp = activity.split('~~'); 
            var actString = arrResp[0]; 
            let hasMore = false; 
            let nextPage    = this.state.nextPage;  
            if(actString===ACTIVITY_LOG_LIST_SUCCESS){ 
                
                if(status===200) {     
                      
                    if(this.props.hasOwnProperty('logData')) {
                        
                        if(this.props.logData.hasOwnProperty('links')) logLinks = this.props.logData.links;  
                        
                        if(this.props.logData.hasOwnProperty('results')) {
                            arrLogResults = [...this.state.arrLogResults, ...this.props.logData.results];  
                        }
                        else {
                            arrLogResults = [...this.state.arrLogResults, ...this.props.logData]; 
                        }
                        
                        
                        if(!Array.isArray(arrLogResults) || arrLogResults.length===0) errLogResultsMsg = MSG_ACTIVITY_LOG_ERROR; 

                        

                        if(this.props.logData.links && this.props.logData.links.next && this.props.logData.links.next.trim().length > 0) {
                            hasMore = true; 
                            nextPage++; 
                        }
                        
                        this.setState({arrLogResults,logLinks,errLogResultsMsg, hasMore:hasMore, nextPage:nextPage}); 
                        
                    } 
                } 
                else if(status!==200) { 
                    errLogResultsMsg = MSG_ACTIVITY_LOG_ERROR; 
                    this.setState({arrLogResults,logLinks,errLogResultsMsg,toastFlag:true,toastSuccess:false,  toastMessage:MSG_SERVER_DATA_FETCH_ERROR, hasMore:hasMore, nextPage:nextPage});
                    setTimeout(()=> {
                        this.onCloseToast(); 
                    }, 4000);
                }
            }
            else if(actString===ACTIVITY_LOG_LIST_ERROR) { 
                errLogResultsMsg = MSG_ACTIVITY_LOG_ERROR; 
                this.setState({arrLogResults,logLinks,errLogResultsMsg,toastFlag:true,toastSuccess:false,  toastMessage:MSG_SERVER_DATA_FETCH_ERROR, hasMore:hasMore, nextPage:nextPage});
                setTimeout(()=> {
                    this.onCloseToast(); 
                }, 4000);
            }
        } 
    }

    render(){
        const { toastMessage,toastFlag,toastSuccess,hasMore } = this.state; 
        const { status } = this.props;  

        let userGroupData = userGroupUrlCheck(this.props.location);
        let userGroup = ''; 
        if(userGroupData!==undefined) userGroup = userGroupData.user_group; 

        if(status===401 || status===403){  
            if(userGroup===staticConfigs.LOGIN_AFFILIATE_GROUP) {
                return <Redirect to={staticConfigs.ROUTE_AFFILIATE_REFRESH} />;
            }
            else if(userGroup===staticConfigs.LOGIN_SUPER_ADMIN_GROUP) {
                return <Redirect to={staticConfigs.ROUTE_REFRESH} />; 
            }
            else if(userGroup===staticConfigs.LOGIN_CLIENT_GROUP) {
                return <Redirect to={staticConfigs.ROUTE_CLIENT_REFRESH} />; 
            }
        }

        // let logString = ''; 
        // let logTime = ''; 
        // let logAction = ''; 
        let timeZone =  getUserTimeZone(window.location);
        return( 
            <React.Fragment>
                {/* // (userGroup===staticConfigs.LOGIN_SUPER_ADMIN_GROUP || (userGroup===staticConfigs.LOGIN_AFFILIATE_GROUP &&)) */}
               {this.props.dataObj.refType==='logMasterPage' && 
                <div className="dashboard dashboardLog">
                    <div className="container">
                        <div className="row"> 
                            <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />
                            <div className="col-md-12">
                                <div className="dashbox">
                                    <div className="box-head">
                                        <h6>{LBL_USER_ACTION_LOGS}</h6>
                                    </div>

                                    { this.state.errLogResultsMsg.length > 0 && 
                                        <div className="log-user-container"><p className="text-red">{MSG_ACTIVITY_LOG_ERROR}</p></div>
                                    }

                                    {this.state.arrLogResults.map((item, index) => {
                                        return(    
                                        <div key={'logRow_'+index} className="log-user-container">
                                            <div className="inner-log">
                                                <p className="text-muted m-0">
                                                    { ReactHtmlParser(this.parseLog(item.log_string,item.content,item.action,userGroup,timeZone.utc_offset)) }
                                                </p>
                                                <h6 className="text-muted m-0"><small>{item.time_string}</small></h6>
                                                    {/* <Moment fromNow>{converDateToLocal(item.created_on,timeZone.utc_offset,'yyyymmddThhmmss','-')}</Moment> */} 
                                            </div>
                                          
                                        </div>        
                                        )
                                        })}

                                    { hasMore &&
                                    <div className="col-12 hasMoreNotifications" >
                                        <Link to="#" onClick={this.loadNextPage} >{LBL_VIEW_MORE}</Link>
                                    </div>
                                    }  
                                    
                                </div>
                            </div> 
                        </div> 
                    </div> 
                </div> }
                

                {(userGroup===staticConfigs.LOGIN_AFFILIATE_GROUP || userGroup===staticConfigs.LOGIN_CLIENT_GROUP  || userGroup===staticConfigs.LOGIN_SUPER_ADMIN_GROUP) && this.props.dataObj.refType!=='logMasterPage' &&  
                <div className="row log-style mt-30">
                    { (this.state.errLogResultsMsg.length > 0) && 
                        <div className="col-12 border-bottom-line">
                            <p className="mb-0"><small>{MSG_ACTIVITY_LOG_ERROR}</small></p>
                        </div>
                    }

                    {this.state.arrLogResults.map((item, index) => {
                        return(    
                        <div key={'logRow_'+index} className={this.state.arrLogResults.length === index + 1?'col-12 border-bottom-linee':'col-12 border-bottom-line'}>
                            <p className="m-0 text-muted"><small>
                            { ReactHtmlParser(this.parseLog(item.log_string,item.content,item.action,userGroup,timeZone.utc_offset)) }</small></p>
                            <div className="row">
                                <div className="col-6 p-0"> 
                                    <h6 className="text-muted m-0"><small>{item.time_string}</small></h6> 
                                </div>                          
                            </div>                        
                        </div>
                        )
                    })}    
                    { hasMore &&
                        <div className="col-12 hasMoreNotifications" ><Link to="#" onClick={this.loadNextPage} >{LBL_VIEW_MORE}</Link>    
                        </div>
                    }                
                </div>  
                }

                {/* {userGroup===staticConfigs.LOGIN_CLIENT_GROUP && this.props.dataObj.refType!=='logMasterPage' &&  
                <div className="row log-style mt-30">
                    { (this.state.errLogResultsMsg.length > 0) && 
                        <div className="col-12 border-bottom-line">
                            <p className="mb-0"><small>{MSG_ACTIVITY_LOG_ERROR}</small></p>
                        </div>
                    }

                    {this.state.arrLogResults.map((item, index) => {
                        return(    
                        <div key={'logRow_'+index} className={this.state.arrLogResults.length === index + 1?'col-12 border-bottom-linee':'col-12 border-bottom-line'}>
                            <p className="m-0 text-muted"><small>
                            { ReactHtmlParser(this.parseLog(item.log_string,item.content,item.action,userGroup)) }</small></p>
                            <div className="row">
                                <div className="col-6 p-0"> 
                                    <h6 className="text-muted m-0"><small><Moment fromNow>{converDateToLocal(item.created_on,timeZone.offset,'yyyymmddThhmmss','-')}</Moment></small></h6> 
                                </div>                          
                            </div>                        
                        </div>
                        )
                    })}    
                    { hasMore &&
                        <div className="col-12 hasMoreNotifications" >
                            <Link to="#" onClick={this.loadNextPage} >{LBL_VIEW_MORE}</Link>
                        </div>
                    }                
                </div>  
                } */}

            </React.Fragment> 
        )
    }
}

const mapStateToProps = (state) => {
    return {
        status:state.activityLog.status,
        activity:state.activityLog.activity,
        logData:state.activityLog.logData,
        totalPage:state.activityLog.totalPage,
        numRows:state.activityLog.numRows,
        count:state.activityLog.count,
    }
}           

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        activityLogListAction:activityLogListAction,  
        clearAction:clearAction
    },dispatch);
} 
export default connect(mapStateToProps,mapDispatchToProps)(LogComponent);

        